import { css } from '@emotion/react'

export const wrapper = css`
  margin-bottom: 2em;
`
